import { Card, TextField, Backdrop, Grid, Autocomplete, MenuItem, Tooltip, InputAdornment, Icon, CircularProgress, IconButton, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import MDTypography from "components/MDTypography";
import { useTranslation } from "react-i18next";
import MDInput from "components/MDInput";
import { Country } from 'country-state-city';
import { useContext } from 'react';
import configurationContext from "contextConfig.js";

const CountryOfOrigin = (props) => {
    const { dataFrom, register, errors, setError, selectedCountryOfOrgin, setSelectedCountryOfOrgin, isDropdownOpen, setIsDropdownOpen } = props;

    const { t } = useTranslation();
    const countries = Country.getAllCountries();
    const MyContext = useContext(configurationContext);

    const handleInputClick = () => {
        setIsDropdownOpen(true);
    };
    return (
        <Card >
            <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                <Grid item xs={12} container spacing={2}>
                    <Grid item xs={12}>
                        <MDTypography variant="h6" className="uppercaseLetters"   >{t('chooseCountryOfOrgin')} </MDTypography>
                        <MDTypography component="span" variant="body2" >{t('countryOfOriginDetailsLabel', { dataFrom: dataFrom })}</MDTypography>
                    </Grid>
                    <Grid item xs={12} lg={12} sm={12} md={12}>
                        <MDInput
                            select
                            name="countryOfOrgin"
                            InputProps={{
                                classes: { root: "select-input-styles " },
                            }}
                            {...register("countryOfOrgin", {})}
                            value={selectedCountryOfOrgin || '0'}
                            onChange={(event) => setSelectedCountryOfOrgin(event.target.value)}
                            fullWidth
                        >
                            <MenuItem key={0} value='0'>{t('selectCountry')}</MenuItem>
                            {countries.map((unit) => (
                                <MenuItem key={unit.isoCode} value={unit.isoCode}>{unit.name}</MenuItem>
                            ))}
                        </MDInput>
                    </Grid>


                    {dataFrom == 'product' && (<>
                        <Grid item xs={12} sm={4} md={4}>
                            <MDTypography variant="body1" className="labelStyle">{t('enterHsnCode')}

                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                            <MDInput
                                type="text"
                                name="hsnCode"
                                defaultValue=""
                                placeholder={t('enterHsnCode')}
                                InputProps={{
                                    classes: { root: "inputBoxStyle" },

                                }}
                                {...register("hsnCode", {

                                })}
                                onChange={((e) => {
                                    e.stopPropagation();

                                })}
                                fullWidth />
                            {errors.hsnCode && <span className="errorMsg FloatRight">{errors.hsnCode.message}</span>}

                        </Grid>

                    </>)}





                </Grid>
            </Grid>
        </Card>
    )


}
export default CountryOfOrigin;
